<mat-toolbar mat-dialog-title color="warn">
  <mat-icon style="margin-right: 0.5em">warning</mat-icon>
  {{ 'retract_dds_tr' | translate }}
</mat-toolbar>

<mat-dialog-content style="padding: 1em 2em">
  <div style="margin-bottom: 1.5em">
    <h3>{{ 'confirm_retraction_tr' | translate }}</h3>
    <p>{{ 'you_are_about_to_retract_the_following_dds_tr' | translate }}:</p>

    <div style="background: #f5f5f5; padding: 1em; border-radius: 4px; margin: 1em 0">
      <div style="margin-bottom: 0.5em">
        <strong>{{ 'product_tr' | translate }}:</strong>
        {{ data.product.name }}
      </div>
      @if (data.product.resultDdr) {
        <div style="margin-bottom: 0.5em">
          <strong>DDR:</strong>
          {{ data.product.resultDdr }}
        </div>
        <div style="margin-bottom: 0.5em">
          <strong>DDV:</strong>
          {{ data.product.resultDdv }}
        </div>
      }
      <div style="margin-bottom: 0.5em">
        <strong>{{ 'Status_tr' | translate }}:</strong>
        {{ data.product.status }}
      </div>
      @if (data.product.submittedWithTarget) {
        <div>
          <strong>{{ 'eudr_environment_tr' | translate }}:</strong>
          {{ data.product.submittedWithTarget }}
        </div>
      }
    </div>
  </div>

  <mat-divider style="margin: 1.5em 0"></mat-divider>

  <div style="background: #fff3cd; border: 2px solid #ffc107; padding: 1em; border-radius: 4px; margin: 1em 0">
    <h4 style="margin-top: 0; color: #856404">
      <mat-icon style="vertical-align: middle; margin-right: 0.5em; color: #856404">error_outline</mat-icon>
      {{ 'warning_important_consequences_tr' | translate }}
    </h4>

    <div style="color: #856404; margin-bottom: 0.75em">
      <strong>{{ 'irreversibility_warning_tr' | translate }}:</strong>
      <p style="margin: 0.25em 0 0 0">{{ 'this_action_cannot_be_undone_retract_tr' | translate }}</p>
    </div>

    <div style="color: #856404">
      <strong>{{ 'compliance_impact_warning_tr' | translate }}:</strong>
      <p style="margin: 0.25em 0 0 0">{{ 'retracted_dds_no_longer_valid_tr' | translate }}</p>
    </div>
  </div>

  <mat-divider style="margin: 1.5em 0"></mat-divider>

  <mat-checkbox [(ngModel)]="confirmed" color="warn" style="margin: 1em 0">
    {{ 'i_understand_and_want_to_retract_tr' | translate }}
  </mat-checkbox>
</mat-dialog-content>

<dialog-form-actions>
  <button type="button" [mat-dialog-close]="true" color="warn" mat-raised-button [disabled]="!confirmed">
    <mat-icon style="margin-right: 0.5em">delete_forever</mat-icon>
    {{ 'retract_dds_tr' | translate }}
  </button>
  <button type="button" [mat-dialog-close]="false" mat-raised-button>{{ 'cancel_tr' | translate }}</button>
</dialog-form-actions>
